import { useMutation, useQueryClient } from "react-query";
import { updateCameraSystem } from "../../../../../actions/Utilities/CameraSystem";
import { toast } from "components/toastNotification";
import { useRecoilState, useSetRecoilState } from "recoil";
import { cameraSystemReFetching, editStateCameraSystem } from "../atoms/atoms";
import { ICameraSystem } from "../types";

const useEditCameraSystem = () => {
  const setActionEditState = useSetRecoilState(editStateCameraSystem);
  const [isReFetching, setIsReFetching] = useRecoilState(
    cameraSystemReFetching
  );
  const { mutate } = useMutation(
    (Data: ICameraSystem) => updateCameraSystem(Data),
    {
      onSuccess: (res) => {
        if (typeof res == "object") {
          toast.fire(
            "Updating Camera System failed",
            `${res.Message}`,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Camera System Updated Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Camera System Updated Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Updating Camera System failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Updating Camera System failed ",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            case res.includes("Action object"):
              toast.fire(
                "Updating Camera System failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Updating Camera System failed", `${res}`, "error");
          }
        }
        // Redirect to View
        setActionEditState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire("Update Camera System failed", `Error: ${error}`, "error");
      },
    }
  );
  return mutate;
};

export default useEditCameraSystem;
